import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";

export default function Hiring() {
    
    return (
        <>            
            <h1 className="dash-title">Hire New Employees </h1>

            <div className="row dash-row">
                <div className="col-md-4 col-sm-4 col-12">
                    <div className="addbox">
                        <h4>ADD INDIVIDUALLY</h4>
                        <p><Link to="/hiring/new-employee"><i className="fa fa-plus"></i></Link></p>
                    </div>
                </div>
                <div className="col-md-4 col-sm-4 col-12">
                    <div className="addbox">
                        <h4>IMPORT DATA</h4>
                        <p><Link to="/hiring/import-employees"><i className="fa fa-users"></i></Link></p>
                    </div>
                </div>
                <div className="col-md-4 col-sm-4 col-12">
                    <div className="addbox">
                        <h4>SEND INVITE LINK</h4>
                        <p><Link to="/hiring/invite-link"><i className="fa fa-envelope"></i></Link></p>
                    </div>
                </div>
            </div>
        </>
    );
}
